import { components } from "@apiSchema";
import dayjs from "dayjs";
import { ISocialPosts, SocialPosts } from "@models/SocialPosts";

export type ApiModel = components["schemas"]["SocialCustomAssociationViewModel"];

export interface IFoodSocialCustomAssociation {
    query: string;
    matchCount: number;
    oneMonthGrowthPct: number | null;
    posts: ISocialPosts;
}

export const DEFAULT_FOOD_SOCIAL_CUSTOM_ASSOCIATION: IFoodSocialCustomAssociation = {
    query: '',
    matchCount: 0,
    oneMonthGrowthPct: null,
    posts: SocialPosts.defaultData,
};

function mapPosts(apiModel: ApiModel): ISocialPosts {
    return {
        dateRangeStr: apiModel.startDate && apiModel.endDate
            ? SocialPosts.getDateRange(dayjs(apiModel.startDate), dayjs(apiModel.endDate))
            : '',
        regular: SocialPosts.mapPosts(apiModel.postsByEngagement ?? []),
        newest: SocialPosts.mapPosts(apiModel.postsByDate ?? []),
        // the endpoint has no sentiment split — these tabs fall back to the empty state
        positive: [],
        negative: [],
    };
}

export function mapFoodSocialCustomAssociation(apiModel: ApiModel): IFoodSocialCustomAssociation {
    return {
        query: apiModel.query ?? '',
        matchCount: apiModel.matchCount ?? 0,
        oneMonthGrowthPct: apiModel.oneMonthGrowth ?? null,
        posts: mapPosts(apiModel),
    };
}
